import { useCallback } from 'react'
import { useColor, TColorNameKey } from '../../theme'
import { PersonaAvailability } from './types'

const AVAILABILITY: Record<PersonaAvailability, TColorNameKey> = {
  away: 'orange',
  busy: 'red',
  offline: 'grey',
  online: 'green',
  unknown: 'white',
}

export const useAvailabilityColor = (): {
  getAvailabilityBadgeColor: (
    availability: PersonaAvailability,
  ) => string
} => {
  const availabilityAwayColor = useColor({
    nuance: AVAILABILITY['away'],
    palette: 'colors',
  })
  const availabilityBusyColor = useColor({
    nuance: AVAILABILITY['busy'],
    palette: 'colors',
  })
  const availabilityOfflineColor = useColor({
    nuance: AVAILABILITY['offline'],
    palette: 'colors',
  })
  const availabilityOnlineColor = useColor({
    nuance: AVAILABILITY['online'],
    palette: 'colors',
  })
  const availabilityUnknownColor = useColor({
    nuance: AVAILABILITY['unknown'],
    palette: 'colors',
  })

  const getAvailabilityBadgeColor = useCallback(
    (availability: PersonaAvailability) => {
      const colors: Record<PersonaAvailability, string> = {
        away: availabilityAwayColor,
        busy: availabilityBusyColor,
        offline: availabilityOfflineColor,
        online: availabilityOnlineColor,
        unknown: availabilityUnknownColor,
      }

      return colors[availability]
    },
    [
      availabilityAwayColor,
      availabilityBusyColor,
      availabilityOfflineColor,
      availabilityOnlineColor,
      availabilityUnknownColor,
    ],
  )

  return {
    getAvailabilityBadgeColor,
  }
}
